export default __webpack_public_path__ + "static/media/business-and-finance.47742ddc.svg";